import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import React, { useCallback } from 'react';
import './SymbolFromConfigOrPortfolioLinkedTitle.scss';
import Tooltip from 'utils/components/Tooltip/Tooltip';

import classNames from 'classnames';
import { useCapsuleBoundSymbol } from 'widgets/tiles/components/tile/hooks';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { useDispatchUpdateWidgetConfiguration } from 'widgets/store/configuration/hooks';
import { WidgetConfigWithSymbol } from 'widgets/WidgetSettingsEditing/WidgetSettingsSymbolEditor';
import { useSymbolInUsersSymbology } from 'symbols/symbolInfo/hooks';

export function SymbolFromConfigOrPortfolioLinkedTitle() {
    const { linked, symbol, symbology } = useCapsuleBoundSymbol();
    const symbolInUsersSymbology = useSymbolInUsersSymbology(symbol, symbology);

    const isLocked = useSelectLocked();
    const dispatchConfigChanged =
        useDispatchUpdateWidgetConfiguration<WidgetConfigWithSymbol>();

    const linkedToCurrentSelection = symbolInUsersSymbology && linked;

    const clickable = !isLocked && (linkedToCurrentSelection || !linked);

    const cssClasses = classNames(
        'SymbolFromConfigOrPortfolioLinkedTitle',
        clickable && 'clickable'
    );

    const onButtonClicked = useCallback(() => {
        if (clickable) {
            const nextSymbol = linked ? symbolInUsersSymbology : '';
            dispatchConfigChanged({ symbol: nextSymbol });
        }
    }, [clickable, dispatchConfigChanged, linked, symbolInUsersSymbology]);

    return (
        <div className={cssClasses}>
            <Tooltip
                text={symbolInUsersSymbology ?? ''}
                neverHide={true}
                className="title"
            >
                {symbolInUsersSymbology ?? ''}
            </Tooltip>
            {symbolInUsersSymbology && !linked && (
                <ToolbarIcon
                    className="SymbolFromConfigOrPortfolioLinkedIcon"
                    name="pin"
                    tooltip={{
                        body: `Pinned to '${symbolInUsersSymbology}'.${
                            clickable
                                ? ' Click to unpin and link to your selection.'
                                : ''
                        }`,
                    }}
                    onClick={onButtonClicked}
                />
            )}
            {symbolInUsersSymbology && linked && (
                <ToolbarIcon
                    className="SymbolFromConfigOrPortfolioLinkedIcon"
                    name="chain"
                    tooltip={{
                        body: `Linked to your portfolio selection.${
                            clickable
                                ? ` Click to pin to '${symbolInUsersSymbology}'.`
                                : ''
                        }`,
                    }}
                    onClick={onButtonClicked}
                />
            )}
        </div>
    );
}
